import { getProperties } from '~modules/properties/api/api-service/property';

import { useEntityList } from '~hooks/api/use-entity-list';

import { ApiHookProps } from '~app/types/api/api-hook';

import { ApiProperty } from '~shared/types';

type Props = ApiHookProps<ApiProperty>;

export const useGetProperties = ({ params, searchBy, options }: Props = {}) => {
  return useEntityList<ApiProperty>('properties', {
    queryFn: getProperties,
    params,
    searchBy,
    keepPrevious: true,
    queryOptions: options,
  });
};
